import { render, staticRenderFns } from "./Fittings.vue?vue&type=template&id=58087e6f&scoped=true"
import script from "./Fittings.vue?vue&type=script&lang=js"
export * from "./Fittings.vue?vue&type=script&lang=js"
import style0 from "./Fittings.vue?vue&type=style&index=0&id=58087e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58087e6f",
  null
  
)

export default component.exports